module.exports = __webpack_public_path__ + "work_team.729d8e14ba2be918caddfa89a31b6a5d.hashedasset.svg";